import { DialogComponentData } from "@obg/mat.ui.core";
import { MultiSessionLimit, MultiSessionLimitResponse } from "@obg/ngx.common";

export const MULTI_SESSION_LIMIT_DIALOG_ID = "multi-session-limit-confirmation";
export interface MultiSessionLimitConfirmationModel extends DialogComponentData {
	upcoming: MultiSessionLimit;
	current?: MultiSessionLimitResponse;
}
